/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockCustomTableQuery = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DashboardPageBlockCustomTableQuery model module.
   * @module model/DashboardPageBlockCustomTableQuery
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockCustomTableQuery</code>.
   * @alias module:model/DashboardPageBlockCustomTableQuery
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>DashboardPageBlockCustomTableQuery</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockCustomTableQuery} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockCustomTableQuery} The populated <code>DashboardPageBlockCustomTableQuery</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Query')) {
        obj['Query'] = ApiClient.convertToType(data['Query'], 'String');
      }
      if (data.hasOwnProperty('PivotByFirstColumn')) {
        obj['PivotByFirstColumn'] = ApiClient.convertToType(data['PivotByFirstColumn'], 'Boolean');
      }
      if (data.hasOwnProperty('FilterByDateRange')) {
        obj['FilterByDateRange'] = ApiClient.convertToType(data['FilterByDateRange'], 'Boolean');
      }
      if (data.hasOwnProperty('PieChartColumnID')) {
        obj['PieChartColumnID'] = ApiClient.convertToType(data['PieChartColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('ShowGraphDefault')) {
        obj['ShowGraphDefault'] = ApiClient.convertToType(data['ShowGraphDefault'], 'Boolean');
      }
      if (data.hasOwnProperty('GraphXAxisColumnID')) {
        obj['GraphXAxisColumnID'] = ApiClient.convertToType(data['GraphXAxisColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('GraphYAxisColumnID')) {
        obj['GraphYAxisColumnID'] = ApiClient.convertToType(data['GraphYAxisColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultStartDate')) {
        obj['DefaultStartDate'] = ApiClient.convertToType(data['DefaultStartDate'], 'Date');
      }
      if (data.hasOwnProperty('DefaultEndDate')) {
        obj['DefaultEndDate'] = ApiClient.convertToType(data['DefaultEndDate'], 'Date');
      }
      if (data.hasOwnProperty('GraphComparisonAxisColumnID')) {
        obj['GraphComparisonAxisColumnID'] = ApiClient.convertToType(data['GraphComparisonAxisColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('GraphSerieTypeID')) {
        obj['GraphSerieTypeID'] = ApiClient.convertToType(data['GraphSerieTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('EditableByCustomers')) {
        obj['EditableByCustomers'] = ApiClient.convertToType(data['EditableByCustomers'], 'Boolean');
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Query
   * @default ''
   */
  exports.prototype['Query'] = '';
  /**
   * @member {Boolean} PivotByFirstColumn
   * @default false
   */
  exports.prototype['PivotByFirstColumn'] = false;
  /**
   * @member {Boolean} FilterByDateRange
   * @default false
   */
  exports.prototype['FilterByDateRange'] = false;
  /**
   * @member {Integer} PieChartColumnID
   */
  exports.prototype['PieChartColumnID'] = undefined;
  /**
   * @member {Boolean} ShowGraphDefault
   * @default false
   */
  exports.prototype['ShowGraphDefault'] = false;
  /**
   * @member {Integer} GraphXAxisColumnID
   */
  exports.prototype['GraphXAxisColumnID'] = undefined;
  /**
   * @member {Integer} GraphYAxisColumnID
   */
  exports.prototype['GraphYAxisColumnID'] = undefined;
  /**
   * @member {Date} DefaultStartDate
   */
  exports.prototype['DefaultStartDate'] = undefined;
  /**
   * @member {Date} DefaultEndDate
   */
  exports.prototype['DefaultEndDate'] = undefined;
  /**
   * @member {Integer} GraphComparisonAxisColumnID
   */
  exports.prototype['GraphComparisonAxisColumnID'] = undefined;
  /**
   * @member {Integer} GraphSerieTypeID
   */
  exports.prototype['GraphSerieTypeID'] = undefined;
  /**
   * @member {Boolean} EditableByCustomers
   * @default false
   */
  exports.prototype['EditableByCustomers'] = false;
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


